module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": _vm.loading,
      "fixed": true
    }
  }) : _vm._e(), _vm._v(" "), _c('v-style', [_vm._v("//body {overflow: hidden}")]), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    class: _vm.size
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../assets/croix.png"),
      "width": "40",
      "height": "40",
      "alt": ""
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('main', {
    class: {
      overlay: _vm.overlay
    }
  }, [_c('div', {
    staticClass: "overlay-container"
  }, [_vm._t("overlay")], 2), _vm._v(" "), _vm._t("main")], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-579f5e55","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ModalDefault.vue
// module id = 3199
// module chunks = 0